export default [
    {
      path: '/admin/wholesale-receipts',
      name: 'wholesale-receipt',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/receipt/index.vue')
    },
    {
      path: '/admin/wholesale-receipts/create',
      name: 'wholesale-receipt-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/receipt/create.vue')
    }
  ]
  